import React, { useRef } from 'react'
import './contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri'
import { BsWhatsapp } from 'react-icons/bs'
import emailjs from 'emailjs-com'

const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_hb9ga9g', 'template_gkpmaac', form.current, '3dES0lpOPomgr6IHP')

    e.target.reset();

  };


  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>*********</h5>
            <a href="mailto:kashyapprakshan@yahoo.com" target='_blank'>Send me a mail</a>
          </article>
          {/*<article className='contact__option'>
            <RiMessengerLine className='contact__option-icon'/>
            <h4>Messenger</h4>
            <h5>devdictator</h5>
            <a href="https://m.me/profile" target='_blank'>Send a message</a>
          </article> */}
          <article className='contact__option'>
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>*********</h5>
            <a href="https://api.whatsapp.com/send?phone=+917736319914" target='_blank'>Send me a message</a>
          </article>
        </div>
        {/*END OF CONTACT OPTIONS*/}
        <form action='' ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required/>
          <input type="text" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact